"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var AudioFactory = /*#__PURE__*/function () {
  function AudioFactory() {
    (0, _classCallCheck2["default"])(this, AudioFactory);
  }

  (0, _createClass2["default"])(AudioFactory, [{
    key: "getAudio",

    /**
     * getAudio is a required method for Audio Factory
     *
     * @param {CreativeLayer} creativeLayer
     * @param {number} speed
     */
    value: function getAudio(creativeLayer, speed) {
      // eslint-disable-line no-unused-vars
      throw new Error('getAudio subclass should implement AudioFactory');
    }
    /**
     * Checks if object is an instance of AudioFactory
     *
     * @param inputObject
     * @returns {boolean}
     */

  }], [{
    key: "isAudioFactory",
    value: function isAudioFactory(inputObject) {
      return inputObject instanceof AudioFactory;
    }
  }]);
  return AudioFactory;
}();

var _default = AudioFactory;
exports["default"] = _default;